import moment from 'moment'
import 'moment/locale/fr';
import 'moment/locale/es';
import 'moment/locale/de';
import 'moment/locale/pt';
import 'moment/locale/it';
import {filters} from './drupalSettings';


export const prepareDates = function ({dateIn, nbNight}) {
  if (!dateIn || !nbNight) return [];
  const dateStart = moment(dateIn, 'YYYY-MM-DD');
  const dateEnd = moment(dateIn, 'YYYY-MM-DD').add(nbNight, 'days');
  return [dateStart.toDate(), dateEnd.toDate()];
}

export const convertDatesToString = (data, format = 'ddd, D MMM.', locale = filters.locale) => {
  const dates = Array.isArray(data)? data : [data];
  return dates.map(date => {
    if (!date) return;
    return moment(date).locale(locale).format(format)
  }).filter(date => !!date).join(' - ');
}

export const convertRoomsToString = (data, wordings = filters?.rooms) => {
  if (!data) return;

  const countGuests = (rooms, guest) => {
    let guests = 0
    rooms.filter(room => room[guest] > 0)
      .forEach((room) => { guests += room[guest] })
    return guests
  }
  const roomsLabel = [];
  const roomsCount = data.length;
  const {
    adult,
    adults,
    child,
    children,
    baby,
    babies,
    room,
    rooms,
  } = wordings || {};

  if (roomsCount > 0) {
    roomsLabel.push(`${roomsCount} ${roomsCount > 1 ? rooms : room}`)

    const adultsCount = countGuests(data, 'adults')
    if (adultsCount > 0) {
      roomsLabel.push(`${adultsCount} ${adultsCount > 1 ? adults : adult}`)
    }

    const childrenCount = countGuests(data, 'children')
    if (childrenCount > 0) {
      roomsLabel.push(`${childrenCount} ${childrenCount > 1 ? children : child}`)
    }

    const babiesCount = countGuests(data, 'babies')
    if (babiesCount > 0) {
      roomsLabel.push(`${babiesCount} ${babiesCount > 1 ? babies : baby}`)
    }
  }
  return roomsLabel.length > 0 ? roomsLabel.join(', ') : null
}
